import { render, staticRenderFns } from "./template-1.vue?vue&type=template&id=9f966fec&scoped=true"
import script from "./template-1.vue?vue&type=script&lang=js"
export * from "./template-1.vue?vue&type=script&lang=js"
import style0 from "./template-1.vue?vue&type=style&index=0&id=9f966fec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f966fec",
  null
  
)

export default component.exports